// extracted by mini-css-extract-plugin
export default {"value":"Countdown_value__0P2yH"};